
import { API_AUTH, SITA } from "./variables.tsx";
import "../App.css";
import { useEffect, useState } from "react";
import "./interface.tsx";

import {Tarjeta} from "../components/tarjeta.tsx";
import { Toast } from "../utilidades/toast.tsx";
import { redireccionar } from "../utilidades/funciones.tsx";
import { Header } from "../utilidades/header.tsx";



export const Menu = ()=>{
    const [usuario, setUsuario] = useState<Usuario|undefined>();


/** COMPRUEBA LOS PERMISOS EN CASO DE ESTAR LOGEADO **/
    useEffect(()=>{
        let init = {
            method: "POST",
            body: JSON.stringify({}),
            header:{
                "Content-Type":"aplication/json"
            }
        };
        fetch(API_AUTH + "/loged",init)
        .then(response=>response.json())
        .catch(err=>console.log(err))
        .then(data=>{
            if(data?.status === "ok"){
                //usuario logeado - continua con el programa
                setUsuario(data.usuario);
                console.log(usuario);
                console.log(data);
            }
            else{
                //usuario no logeado redirige al formulario de inicio de sesión
                redireccionar(SITA + "/login");
 /* OBJETO DE PRUEBA               
                setUsuario({
                    "Id":"0",
                    "User":"a",
                    "Nombre":"aa",
                    "Email":"",
                    "Documentos":1,
                    "Registros":1,
                    "Compras":0 ,
                    "Mantenimiento":0,
                    "Calibracion":1,
                    "RRHH":0,
                    "Informes":0,
                    "Auditoria":1,
                    "Administrador":1,
                    "Estado":""
                })
fin objeto de prueba */
            }
        })
    },[])


    return(
    <>
        <Header user={usuario}/>
    {
        usuario?
        <div
            className="container-fluid"
        > 
            <div
                className="row justify-content-center align-items-center g-2"
            >
                <div className="col justify-content-center">
                    <Tarjeta
                        titulo="DOCUMENTOS"
                        icono="bi bi-journal-bookmark"
                        url={SITA + "/documentos"}
                        disabled={usuario.Documentos>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="REGISTROS"
                        icono="bi bi-card-list"
                        url={SITA + "/registros"}
                        disabled={usuario.Registros>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="COMPRAS"
                        icono="bi bi-cart-check"
                        url={SITA + "/compras"}
                        disabled={usuario.Compras>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="MANTENIMIENTO"
                        icono="bi bi-tools"
                        url={SITA + "/mantenimiento"}
                        disabled={usuario.Mantenimiento>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="CALIBRACIONES"
                        icono="bi bi-crosshair"
                        url={SITA + "/calibracion"}
                        disabled={usuario.Calibracion>0?false:true}
                    />
                </div>
            </div>
                <hr />
            <div
                className="row justify-content-center align-items-center g-2"
            >
                <div className="col">
                    <Tarjeta 
                        titulo="CERTIFICACIONES" 
                        icono="bi bi-award"
                        //icono="bi bi-patch-check" 
                        url={SITA + "/certificados"}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="AUDITORÍA"
                        icono="bi bi-shield-check"
                        url={SITA + "/auditorias"}
                        disabled={usuario.Auditoria>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="RRHH"
                        icono="bi bi-person-rolodex"
                        url={SITA + "/recursos-humanos"}
                        disabled={usuario.RRHH>0?false:true}
                    />
                </div>
                <div className="col">
                    <Tarjeta
                        titulo="INFORMES"
                        icono="bi bi-clipboard2-data"
                        url={SITA + "/informes"}
                        disabled={usuario.Informes>0?false:true}
                    />
                </div>
            </div>
        </div>
        :
        <div></div>
    }
      
    </>
    );
}